import PropTypes from 'prop-types';

interface ITotalOrderItemProps {
  href?: string;
  isLink?: boolean;
  isNegative?: boolean;
  alignStart?: boolean;
  boldValue?: boolean;
  title: string;
  value?: string | number;
  className?: string;
  boldTitle?: boolean;
}

const TotalOrderItem = ({
  href,
  isLink,
  isNegative,
  alignStart,
  boldValue,
  title,
  value,
  className,
  boldTitle,
  ...props
}: ITotalOrderItemProps) => (
  <div
    className={[
      `d-flex space-between ${alignStart ? 'align-start' : 'align-center'}`,
      className,
    ].join(' ')}
    {...props}
  >
    <div className={`${boldTitle ? 'fw-bold' : ''}`}>{title}</div>
    {isLink ? (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className={`${boldValue ? 'fw-bold' : ''} text-nowrap`}
      >{`${isNegative ? '-' : ''}${value}`}</a>
    ) : (
      <div
        className={`${boldValue ? 'fw-bold' : ''} text-nowrap`}
      >{`${isNegative ? '-' : ''}${value || ''}`}</div>
    )}
  </div>
);

TotalOrderItem.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
};

export default TotalOrderItem;
